export function HomePage() {
  return (
    <main>
      <h1>FindOp Console</h1>
      <p>Multi-SaaS Management Platform</p>
    </main>
  );
}
